import axios from 'axios';

const API_BASE_URL =
  process.env.REACT_APP_API_URL ||
  (process.env.NODE_ENV === 'production' ? '/api' : 'http://localhost:5000/api');

function baseForScope(scope = 'sleep-videos') {
  if (scope === 'ai-stories') {
    return `${API_BASE_URL}/ai-stories/voice-over-configs`;
  }
  return `${API_BASE_URL}/sleep-videos/voice-over-configs`;
}

class VoiceOverConfigService {
  async list(scope = 'sleep-videos') {
    const response = await axios.get(baseForScope(scope));
    return response.data;
  }

  async get(id, scope = 'sleep-videos') {
    const response = await axios.get(`${baseForScope(scope)}/${id}`);
    return response.data;
  }

  async create(data, scope = 'sleep-videos') {
    const response = await axios.post(baseForScope(scope), {
      name: data.name?.trim() || '',
      provider: data.provider || 'j1',
      voice_id: data.voice_id?.trim() || '',
      model_id: data.model_id?.trim() || 'eleven_multilingual_v2',
      stability: data.stability ?? 0.5,
      similarity_boost: data.similarity_boost ?? 0.75,
      style: data.style ?? 0,
      use_speaker_boost: data.use_speaker_boost ?? false,
      speed: data.speed ?? 1.0,
    });
    return response.data;
  }

  async update(id, data, scope = 'sleep-videos') {
    const payload = {};
    if (data.name !== undefined) payload.name = data.name;
    if (data.provider !== undefined) payload.provider = data.provider;
    if (data.voice_id !== undefined) payload.voice_id = data.voice_id;
    if (data.model_id !== undefined) payload.model_id = data.model_id;
    if (data.stability !== undefined) payload.stability = data.stability;
    if (data.similarity_boost !== undefined) payload.similarity_boost = data.similarity_boost;
    if (data.style !== undefined) payload.style = data.style;
    if (data.use_speaker_boost !== undefined) payload.use_speaker_boost = data.use_speaker_boost;
    if (data.speed !== undefined) payload.speed = data.speed;
    const response = await axios.put(`${baseForScope(scope)}/${id}`, payload);
    return response.data;
  }

  async delete(id, scope = 'sleep-videos') {
    const response = await axios.delete(`${baseForScope(scope)}/${id}`);
    return response.data;
  }
}

export default new VoiceOverConfigService();
